import { Injectable } from '@angular/core';
import { defaultConfig } from '../app.general';
import { EventManagerService } from './event-manager.service';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  params = {};

  constructor(private _eventManager: EventManagerService) {
    this.updateConfiguration(defaultConfig);
  }

  updateConfiguration(configParams) {
    const parmaNames = Object.keys(configParams);
    parmaNames.forEach((paramName) => {
      this.params[paramName] = configParams[paramName];
    });
    this._eventManager.next('configLoaded', this.params);
  }

  getParameter(paramName) {
    return this.params?.[paramName] ?? null;
  }
}
